module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-评论.1ced2.png";